import { render, staticRenderFns } from "./formsUi.vue?vue&type=template&id=5c6e7b58&scoped=true"
import script from "./formsUi.vue?vue&type=script&lang=js"
export * from "./formsUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6e7b58",
  null
  
)

export default component.exports